<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="error" dark v-bind="attrs" v-on="on" class="mr-5">
        Update
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline"> Update Email </v-card-title>
      <v-card-text>
        <v-form ref="form" @submit.prevent="handleUpdateEmail" v-model="valid">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  label="Email"
                  name="email"
                  :rules="rules.emailRules"
                  value
                ></v-text-field>
              </v-col>

              <v-btn
                type="submit"
                :disabled="!valid"
                color="#FC4A46"
                class="register"
                >Submit</v-btn
              >
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      valid: false,
      dialog: false,
      email: null,
      rules: {
        required: (value) => !!value || 'Required.',
        min: (v) => v.length >= 8 || 'Min 8 characters',
        emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+/.test(v) || 'E-mail must be valid',
        ],
      },
    };
  },
  methods: {
    handleUpdateEmail() {
      this.$store.dispatch('HANDLE_UPDATE_EMAIL', {
        email: this.email,
        userId: this.$store.getters.getUserId,
      });
    },
  },
};
</script>
